// extracted by mini-css-extract-plugin
export default {"container":"DataTable_container__YZtdm","isScrollable":"DataTable_isScrollable__beheU"};